export const profileSection = {
    services: [{ field: 'Prodaja' }, { field: 'Najam/zakup' }],
    types: [{ field: 'Kuća' }, { field: 'Stan' }, { field: 'Poslovni prostor' }, { field: 'Zemljište' }, { field: 'Garaža' }],
    subTypes: { field: 'Podtip nekretnine' },
}

export const locationSection = [
    { field: 'Država' },
    { field: 'Županija' },
    { field: 'Grad/općina' },
    { field: 'Šira lokacija' },
    { field: 'Uža lokacija' },
    { field: 'Otok' },
    { field: 'Ulica' },
    { field: 'Kućni broj', shortLine: true },
    { field: 'Broj/oznaka', shortLine: true },
    { field: 'Pozicija (poslovni prostor)' },
]

export const priceSection = {
    line: [
        { field: 'Cijena (€)' },
        { field: 'Početna cijena (€) (Prodaja)' },
        { field: 'Cijena klijenta (€)' },
        { field: 'Cijena (€/m²)' },
        { field: 'Stara cijena (€)' },
        { field: 'Otkup / hipoteka' },
        { field: 'Provizija agencije' },
        { field: 'Zajednički troškovi održavanja/Pričuva (€) ili (€/m²)', isRent: true },
        { field: 'Zajednički troškovi režija zgrade (€) ili (€/m²) (Najam/zakup)', isRent: true },
    ],
    checkbox: {
        sale: [{ field: 'Cijena na upit' }, { field: 'Moguća zamjena' }, { field: 'PDV uključen u cijenu' }],
        rent: [{ field: '(+PDV) (Najam/zakup)' }, { field: 'Režije uključene u cijenu (Najam/zakup)' }],
    },
}

export const generalInfoSection = {
    area: [
        { field: 'Površina (m²)' },
        { field: 'Neto površina (m²)' },
        { field: 'Površina okućnice (m²)' },
        { field: 'Parcela (m²) (Kuća)' },
        { field: 'Površina skladišta/arhive (m²) (Poslovni prostor)', fullWidth: true },
    ],
    land: [
        { field: 'Širina zemljišta (m) (Zemljište)' },
        { field: 'Dužina zemljišta (m) (Zemljište)' },
        { field: 'Koeficijent izgrađenosti (%) (Zemljište)' },
        { field: 'Katnost izgradnje (%) (Zemljište)' },
        { field: 'BRP (m2) (Zemljište)' },
    ],
    rooms: [
        { field: 'Vrsta kuće' },
        { field: 'Prostorije (Kuća/Poslovni prostor)' },
        { field: 'Stambene jedinice (Kuća)' },
        { field: 'Ležajevi (Kuća)' },
        { field: 'Sobe (Stan)' },
        { field: 'Spavaće sobe' },
        { field: 'Kupaonice s toaletom' },
        { field: 'Kupaonice bez toaleta' },
        { field: 'Toaleti' },
    ],
    utilities: [
        { field: 'Visina stropa (m)', fullWidth: true },
        { field: 'Broj etaža', fullWidth: true },
        { field: 'Etaže (Stan/Poslovni prostor/Garaža)', fullWidth: true },
        { field: 'Godina izgradnje' },
        { field: 'Godina adaptacije' },
        { field: 'Kat (Stan/Poslovni prostor/Garaža)' },
        { field: 'Od katova (Stan/Poslovni prostor/Garaža)' },
        { field: 'Parkirna mjesta (Poslovni prostor)' },
        { field: 'Orijentacija', longLine: true },
        { field: 'Grijanje', longLine: true },
        { field: 'Stanje nekretnine', longLine: true },
        { field: 'Stolarija', longLine: true },
        { field: 'Javni prijevoz', longLine: true },
    ],
    distance: [
        { field: 'Udaljenost od mora (m)' },
        { field: 'Udaljenost od rijeke (m)' },
        { field: 'Udaljenost od plaže (m)' },
        { field: 'Udaljenost od centra (m)' },
        { field: 'Udaljenost od škole (m)' },
        { field: 'Udaljenost od javnog prijevoza (m)' },
    ],
    details: [
        { field: 'Posebnosti' },
        { field: 'Opis nekretnine' },
        { field: 'Osnovna infrastruktura' },
        { field: 'Opremljenost nekretnine' },
        { field: 'Energetski certifikat' },
        { field: 'Dozvole' },
        { field: 'Pristup nekretnini (Poslovni prostor)', fullWidth: true, shortLine: true },
    ],
    propertySpace: {
        title: { field: 'Prostori vezani uz nekretninu' },
        line: [
            { field: 'Balkon' },
            { field: 'Blagovaona' },
            { field: 'Dnevni boravak' },
            { field: 'Drvarnica' },
            { field: 'Galerija' },
            { field: 'Garaža' },
            { field: 'Garažno mjesto' },
            { field: 'Garderoba' },
            { field: 'Gospodarska soba' },
            { field: 'Hodnik' },
            { field: 'Kuhinja' },
            { field: 'Kupaonica' },
            { field: 'Ljetna kuhinja' },
            { field: 'Loggia' },
            { field: 'Ostava' },
            { field: 'Parking' },
            { field: 'Parking - natkriveni' },
            { field: 'Podrum' },
            { field: 'Spavaća soba' },
            { field: 'Spremište' },
            { field: 'Tavan' },
            { field: 'Terasa' },
            { field: 'Toalet' },
            { field: 'Vrt/dvorište' },
            { field: 'Zimski vrt' },
            { field: 'Gospodarska zgrada' },
            { field: 'Poslovni prostor' },
            { field: 'Vinski podrum' },
            { field: 'Soba' },
            { field: 'Skladište' },
        ],
    },
}

export const descriptionSection = [{ field: 'Naslov' }, { field: 'Opis' }]

export const contactSection = {
    main: [
        { field: 'Ime' },
        { field: 'Prezime' },
        { field: 'Br. tel. 1' },
        { field: 'Br. tel. 2' },
        { field: 'Email' },
        { field: 'Ulica' },
        { field: 'Kućni broj' },
        { field: 'Poštanski broj' },
        { field: 'Grad/općina' },
        { field: 'Država' },
    ],
    other: [{ field: 'OIB' }, { field: 'Spol' }, { field: 'Datum rođenja' }, { field: 'Mjesto rođenja' }, { field: 'Država rođenja' }],
}

export const footerSection = [{ field: 'Agent' }, { field: 'Datum prijema' }]
